import React from 'react';
import './AdyenMobilePayAnonymousInfo.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import ErrorIcon from 'new-images/error.svg';
import {Message} from 'compositions/message/Message';

export const ADYEN_MOBILE_PAY_ANONYMOUS_INFO_POPUP = 'ADYEN_MOBILE_PAY_ANONYMOUS_INFO_POPUP';

export const AdyenMobilePayAnonymousInfo = ({title, description, description2, control, onOverlayClick}) => {
	return <DrawerPopup
		onOverlayClick={onOverlayClick}
	>
		<div className="error-message">
			<div className="error-message__message">
				<Message
					icon={ErrorIcon}
					title={title}
					description={description}
					description2={description2}
				/>
			</div>
			{
				control && <div className="error-message__control">
					{control}
				</div>
			}
		</div>

	</DrawerPopup>
}
